// extracted by mini-css-extract-plugin
export default {"home":"home_home__ElSJg","login":"home_login__8kWIi","start":"home_start__DQlVP","parameters":"home_parameters__hjlZX","startButton":"home_startButton__AOQ7x"};